import { useActivityBuilderTheme } from 'approot/activity-builder/theme/activity-builder-theme';
import { useMultipleChoiceUpdate } from '../settings/multiple-choice-settings.hooks';
import {
  generateTextFieldKey,
  updateOptionText,
} from '../settings/multiple-choice-settings.utils';
import { EditProps, MultipleChoiceOption } from '../multiple-choice.constants';
import MultipleChoiceCheck from './multiple-choice-check';
import MultipleChoiceRadio from './multiple-choice-radio';
import { canShowOptionLetter } from '../multiple-choice.utils';
import { MultipleChoiceLetter } from '../multiple-choice';
import * as Styled from './multiple-choice-edit-list.style';
import { useInputFieldState } from '../../component.hooks';
import MultipleChoiceEditTextField from '../text/multiple-choice-edit-text-field';
import { LANGUAGE_CODE_EN_AU } from 'global/constants';

type Props = EditProps & {
  index: number;
  isOneOptionCorrect: boolean;
  option: MultipleChoiceOption;
};

const MultipleChoiceEditList = ({
  properties,
  subActivityProperties,
  suggestedAnswerProperties,
  sectionId,
  id,
  type,
  sort,
  index,
  isOneOptionCorrect,
  option,
  version,
}: Props) => {
  const { theme } = useActivityBuilderTheme();

  const { handleUpdate } = useMultipleChoiceUpdate({
    id,
    sectionId,
    type,
    sort,
    properties,
    subActivityProperties,
    suggestedAnswerProperties,
    language: LANGUAGE_CODE_EN_AU,
    version,
  });

  const { setEditorStateToUpdate } = useInputFieldState<string>({
    onChange: data => {
      if (option.itemId) {
        handleUpdate({
          ...properties,
          multipleChoice: {
            ...properties.multipleChoice,
            options: updateOptionText(
              properties.multipleChoice.options,
              option.itemId,
              data
            ),
          },
        });
      }
    },
  });

  const content = (
    <>
      {canShowOptionLetter(properties.multipleChoice.showOptionLetter) && (
        <MultipleChoiceLetter
          data-selector="multiple-choice-letter"
          index={index}
        />
      )}
      <MultipleChoiceEditTextField
        key={generateTextFieldKey(theme.font.medium.size, properties)}
        index={index}
        text={option.text}
        onChange={value => setEditorStateToUpdate(value)}
      />
    </>
  );

  return (
    <Styled.MultipleChoiceEditList>
      {isOneOptionCorrect ? (
        <MultipleChoiceRadio
          disabled
          label={content}
          id={`${id}-${index}`}
          name={id}
        />
      ) : (
        <MultipleChoiceCheck disabled label={content} name={id} />
      )}
    </Styled.MultipleChoiceEditList>
  );
};

export default MultipleChoiceEditList;
